import { useCallback } from 'react';

import { useUser } from 'context/userContext';

import { fullStoryIdentity } from 'utils/identity/trackingIdentity';

import { isLocalhost } from 'utils/urlUtils';

export const useFullStory = () => {
  const { userDetails, modules, moduleProjects } = useUser();

  const initiateFullStory = useCallback(() => {
    const { FS: FullStory } = window;
    if (userDetails?.email && !isLocalhost()) {
      const currentModule = modules?.find(module => module.isCurrent);
      const currentProject = currentModule
        ? moduleProjects(currentModule.key)?.find(
            project => project.projectID === currentModule.currentProject,
          )
        : undefined;
      if (FullStory) {
        // #194: the shared person id once the API issues one, else today's hashid.
        FullStory('setIdentity', fullStoryIdentity({ userDetails, currentModule, currentProject }));
      }
    }
  }, [userDetails, modules, moduleProjects]);

  return { initiateFullStory };
};
